export const MAIN_BANNER_FEATURES = [
  "수강 완료 후 발급",
  "실제 제출 사례 기반",
  "변호사 협력 교육 과정",
];

export const MAIN_BANNER_CONTENT = {
  badge: "변호사 협력 기반",
  title: "재범방지 전문 교육기관",
  subtitle:
    "재범방지를 위한 교육 과정부터 수료 문서 발급까지,\n책임 있는 변화의 과정을 체계적으로 지원합니다",
  primaryCta: { label: "수강 신청하기", to: "/courses" },
  secondaryCta: { label: "교육과정 보기", to: "/courses" },
};
